<div
  class="transaction flex items-center w-full h-10 rounded-sm mr-2"
  [class.notdone]="!transaction.allItemsBack() || transaction.items.length == 0"
>
  <div class="transaction-location ml-2 text-nowrap text-ellipsis overflow-hidden">{{ transaction.location }}</div>
  <div class="transaction-startdate ml-auto text-sm text-muted-color text-nowrap text-ellipsis">
    {{ transaction.startdate | date: 'dd.MM.yyy' }}&nbsp;-&nbsp;
  </div>
  @if (transaction.enddate) {
    <div class="transaction-enddate text-sm text-muted-color text-nowrap text-ellipsis">{{ transaction.enddate | date: 'dd.MM.yyy' }}</div>
  }
  @if (!transaction.enddate) {
    <div class="transaction-enddate text-sm text-muted-color text-nowrap text-ellipsis">{{ 'general.now' | translate }}</div>
  }

  <div class="transaction-actions ml-2 flex justify-end items-center">
    @if (showPrintButton) {
      <p-button [rounded]="true" [text]="true" (onClick)="printTransactionChecklist(transaction)">
        <mat-icon color="white">receipt_long</mat-icon>
      </p-button>
    }
    @if (showViewButton) {
      <p-button [rounded]="true" [text]="true" (onClick)="view.emit()">
        <mat-icon color="white">visibility</mat-icon>
      </p-button>
    }
    @if (showSelectButton) {
      <p-button [rounded]="true" [text]="true" (onClick)="selected.emit()">
        <mat-icon color="white">arrow_forward</mat-icon>
      </p-button>
    }
    @if (showUnlinkButton) {
      <p-button [rounded]="true" [text]="true" (onClick)="unlink.emit()">
        <mat-icon color="white">attach_file_off</mat-icon>
      </p-button>
    }
  </div>
</div>
